<template>
  <div>
    <div class="xinwen">
            <!--top-->
            <div class="top">
                <!--nav-->
                <Nav></Nav>    
                <!--nav-end-->
            </div>
            <!--top-end-->
          
            <div class="xinwen-center">
                <div class="center">
                    <h4>{{detailObj.title}}</h4>
                    <h6 v-if="type!=1">{{detailObj.publishTime}}</h6>
                    <div v-html="detailObj.content"></div>
                </div>
            </div>



            <Footer></Footer>
        </div>
        <Backtop></Backtop>
  </div>
</template>

<script>
import Nav from '@c/Main/Nav/index.vue'
import Footer from '@c/Main/Footer/index.vue'
import Backtop from '@c/Main/Backtop/index.vue'
import { newsDetail,giftDetail } from '@/Apis/functions/user'
export default {
    name:'detail',
    components: { Nav, Footer, Backtop },
    data(){
        return {
           detailObj:{},
           type: this.$route.query.gift,
        }
    },
    mounted(){
        if(this.type==1){
            giftDetail({
                merchantId:'dwj',
                id: this.$route.query.id
            }).then(res => {
                if (res.status == 200) {
                    this.detailObj = {...res.data,title:res.data.name,content:res.data.introduction}
                }
            })
        } else {
            newsDetail({
                merchantId:'dwj',
                id: this.$route.query.id
            }).then(res => {
                if (res.status == 200) {
                    this.detailObj = res.data
                }
            })
        }
    }
}
</script>
<style>
@import '~@/static/skin/web/css/xinwenxiangqing.css';
</style>